import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const ImagingIntegration = ({ patientId }) => {
  const navigate = useNavigate();

  const recentImages = [
    {
      id: 1,
      type: 'Bitewing',
      date: '2026-01-15',
      tooth: '#14-15',
      status: 'reviewed',
      thumbnail: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='150'%3E%3Crect fill='%23e5e7eb' width='200' height='150'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' fill='%236b7280' font-size='14'%3EBitewing%3C/text%3E%3C/svg%3E"
    },
    {
      id: 2,
      type: 'Panoramic',
      date: '2026-01-10',
      tooth: 'Full Arch',
      status: 'reviewed',
      thumbnail: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='150'%3E%3Crect fill='%23dbeafe' width='200' height='150'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' fill='%233b82f6' font-size='14'%3EPanoramic%3C/text%3E%3C/svg%3E"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-xl border border-border p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-semibold text-foreground mb-1">Dental Imaging</h2>
            <p className="text-sm text-muted-foreground">View and manage patient radiographs</p>
          </div>
          <Button 
            variant="default" 
            iconName="ExternalLink" 
            iconPosition="left"
            onClick={() => navigate('/dental-imaging-management')}
          >
            Open Imaging Module
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {recentImages?.map((image) => (
            <div key={image?.id} className="bg-background rounded-lg border border-border p-4 hover:shadow-elevation-2 transition-all cursor-pointer">
              <img 
                src={image?.thumbnail} 
                alt={`${image?.type} X-ray`}
                className="w-full h-32 object-cover rounded-lg mb-3"
              />
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-semibold text-foreground">{image?.type}</h3>
                <span className="px-2 py-1 rounded text-xs font-medium bg-success/10 text-success border border-success/20">
                  {image?.status}
                </span>
              </div>
              <p className="text-sm text-muted-foreground">{image?.tooth}</p>
              <p className="text-xs text-muted-foreground">{image?.date}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-primary/5 rounded-lg border border-primary/20 p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-1" />
          <div>
            <h4 className="font-semibold text-foreground mb-1">Quick Access</h4>
            <p className="text-sm text-muted-foreground">
              For full imaging capabilities including X-ray machine connection, DICOM viewing, and advanced annotations, 
              use the dedicated Dental Imaging Management module.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagingIntegration;